import React, {useRef} from 'react';
import cn from 'classnames';

import {setRef} from 'brand/app/utils/refs';
import {useProductVisibilityChange} from 'brandHooks/useProductVisibilityChange';

import {IProductHitProps} from './IProductHit';
import {ProductHitProvider} from './ProductHitContext';

import styles from './ProductHit.module.scss';

const ProductHit = ({product, children, classNames, position, eventOnClick, sourceOverwritten, ref}: IProductHitProps) => {
	const productHitRef = useRef(null);

	useProductVisibilityChange(productHitRef, product?.getProductId());

	return (
		<ProductHitProvider
			initialProduct={product}
			position={position}
			eventOnClick={eventOnClick}
			sourceOverwritten={sourceOverwritten}
		>
			<div
				ref={(node) => {
					const cleanupRef = setRef(ref, node);

					productHitRef.current = node;

					return () => {
						productHitRef.current = null;
						cleanupRef?.();
					};
				}}
				className={cn(styles['product-hit'], 'product-hit', classNames)}
			>
				{children}
			</div>
		</ProductHitProvider>
	);
};

export default ProductHit;
